// Tabs.tsx
import React, { useState } from "react";
import SearchBar from "../Searchbar/Searchbar";
import MyMapComponent from "../../../Maps/MyMapComponent";

interface Tab {
  badge: boolean;
  label: string;
  content: React.ReactNode;
  badgeValue?: number | undefined;
  Uri: string
}

interface TabsProps {
  tabs: Tab[];
  tableData: any[];
  mapsData: any[];
  setSelectedNode: React.Dispatch<React.SetStateAction<{
    id: string;
    label: string;
  }>>;
  handleLogout: () => void;
  setWellData: React.Dispatch<React.SetStateAction<any[]>>;
  pageSize: number;
  setPageSize: React.Dispatch<React.SetStateAction<number>>;
  pageSelected: string;
  setPageSelected: React.Dispatch<React.SetStateAction<string>>,
  intialHeaders: any[],
  intialColumns: any[],
  dashboardData?: any[];
}

const Tabs: React.FC<TabsProps> = ({ tabs, tableData, mapsData, setSelectedNode, handleLogout, setWellData, pageSize, setPageSize, pageSelected, setPageSelected, intialHeaders, intialColumns, dashboardData }) => {
  const [activeTab, setActiveTab] = useState(0);

  const onClickhandler = (index: number, uri: string) => {
    setActiveTab(index)
  }

  return (
    <div className="flex flex-col w-full">
      {/* Tab Labels */}

      <div className="flex mb-1 bg-darkcolor-700">
        {tabs.map((tab, index) => (
          <div
            key={index}
            className={`${activeTab === index
              ? "border-b-[2px] border-secondary-500 text-primary-400 font-semibold"
              : "hover:bg-darkcolor-600 hover:border-none cursor-pointer"
              } px-4 focus:outline-none flex justify-center items-center gap-[8px] py-2`}
            onClick={() => onClickhandler(index, tab.Uri)}
          >
            <div className="flex items-center">
              <span className="text-[16px]">{tab.label}</span>
              {tab.badge && (
                <span className="ml-2 py-0 px-[4px] rounded-[2px] bg-secondary-500 text-white text-[12px]">
                  {tab.badgeValue}
                </span>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Tab Content */}
      {activeTab === 1 ? <> <MyMapComponent mapsData={mapsData} /></> :
        <div className="text-Darkmode-700 p-3">
          <SearchBar tableData={tableData} intialHeaders = {intialHeaders} intialColumns = {intialColumns} setWellData={setWellData} setSelectedNode={setSelectedNode} handleLogout={handleLogout} pageSize={pageSize} setPageSize={setPageSize} pageSelected={pageSelected} setPageSelected={setPageSelected} dashboardData={dashboardData} />
        </div>
      }
    </div>
  );
};

export default Tabs;
